import { useCallback } from 'react';

import { Button } from '@bambi/component-library/src/components/Button/Button';
import { ArrowsUpDownIcon } from '@heroicons/react/24/outline';
import { useFormContext } from 'react-hook-form';

import { AddTripFormValues } from '../FormValues';
import { useIsSelectedTripInThePast } from '../useIsSelectedTripInThePast';

interface SwapAddressesButtonProps {
  index: number;
  onSwap: () => void;
}

export function SwapAddressesButton({
  index,
  onSwap,
}: SwapAddressesButtonProps) {
  const form = useFormContext<AddTripFormValues>();

  const isSelectedTripInThePast = useIsSelectedTripInThePast();
  const handleSwap = useCallback(() => {
    const pickup = form.getValues(`trips.${index}.pickupLocation`);
    const dropoff = form.getValues(`trips.${index}.dropoffLocation`);
    form.setValue(`trips.${index}.pickupLocation`, dropoff, {
      shouldDirty: true,
      shouldValidate: true,
      shouldTouch: true,
    });

    form.setValue(`trips.${index}.dropoffLocation`, pickup, {
      shouldDirty: true,
      shouldValidate: true,
      shouldTouch: true,
    });
    onSwap();
  }, [form, index, onSwap]);

  return (
    <Button
      className="w-full"
      variant="secondary"
      onClick={handleSwap}
      ariaLabel="Swap pickup and dropoff addresses"
      dataTestId="trip-leg-swap-pickup-dropoff"
      disabled={isSelectedTripInThePast}
    >
      <ArrowsUpDownIcon className="h-5 w-5" />
    </Button>
  );
}
